module.exports = __webpack_public_path__ + "img/flight-hotel.dbd58ffb.svg";